import { type WeightData } from "../../../models/WeightData";
import * as WeightUtils from "../../../utils/WeightUtils";

export interface Props {
  weight: WeightData;
}

export const WeightFormat = (props: Props) => <span>{WeightUtils.text(props.weight)}</span>;
